import { render, staticRenderFns } from "./InactiveReserved.vue?vue&type=template&id=3f205dc6&"
import script from "./InactiveReserved.vue?vue&type=script&lang=js&"
export * from "./InactiveReserved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports